<template>
  <div class="px-4 sm:px-0">
    <div class="text-28 font-bold">{{ getHoroscopeName(horoscope) }} Burcunun Diğer Burçlarla Uyumu</div>
    <div class="text-md font-normal mt-3 mb-4">İlişkinizin uyumluluğunu kontrol edin</div>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
      <OButton
        v-for="item in horoscopes"
        :key="item.slug"
        pure
        :href="getHoroscopeCompatibilityUrl(horoscope, item.slug)"
        @mouseenter="hoverHoroscope = item.slug"
        @mouseleave="hoverHoroscope = null"
      >
        <div class="flex bg-[#181819] border border-[#A5B2EC] rounded-3xl p-6 gap-3">
          <div class="flex-1 flex flex-col justify-between">
            <div class="text-24 font-semibold text-left">{{ getHoroscopeName(horoscope) }} & {{ item.name }}</div>
            <div class="text-lg font-medium flex items-center">
              Uyumu Gör
              <OIcon icon="right-white" class="w-6 h-6" />
            </div>
          </div>
          <div class="flex-1 w-[150px] h-[150px] border border-[#6842EF] overflow-hidden">
            <OImage
              :src="getHoroscopeImageUrl(item.slug, hoverHoroscope !== item.slug)"
              class="w-full h-full object-center object-cover scale-125"
            />
          </div>
        </div>
      </OButton>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from '@nuxtjs/composition-api';
import {
  getHoroscopes,
  getHoroscopeName,
  getHoroscopeImageUrl,
  getHoroscopeCompatibilityUrl,
} from '@/modules/astrology/utils/astrologyUtils';
import { OIcon, OImage, OButton } from '@/modules/common/components/ui';

export default defineComponent({
  components: {
    OIcon,
    OImage,
    OButton,
  },
  props: {
    horoscope: {
      type: String,
      default: 'aries',
    },
  },
  setup() {
    const horoscopes = getHoroscopes();
    const hoverHoroscope = ref(null);
    return {
      horoscopes,
      getHoroscopeName,
      getHoroscopeImageUrl,
      getHoroscopeCompatibilityUrl,
      hoverHoroscope,
    };
  },
});
</script>
